import { FC, ReactNode } from 'react';
import { createBemBlockBuilder } from '@ebsco-ui/ebsco-ui';

import { RedirectToLoginButton } from '@app/components';

interface GuestUserModalStateProps {
  message: ReactNode;
}

const cnBem = createBemBlockBuilder(['modal']);

export const GuestUserModalState: FC<GuestUserModalStateProps> = ({
  message,
}) => (
  <div className={cnBem('__signInMessage')}>
    <div>{message}</div>
    <RedirectToLoginButton />
  </div>
);
